/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntegrationEventTooltipsResident
 */
export interface IntegrationEventTooltipsResident {
    /**
     * 
     * @type {string}
     * @memberof IntegrationEventTooltipsResident
     */
    message?: string;
}

/**
 * Check if a given object implements the IntegrationEventTooltipsResident interface.
 */
export function instanceOfIntegrationEventTooltipsResident(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IntegrationEventTooltipsResidentFromJSON(json: any): IntegrationEventTooltipsResident {
    return IntegrationEventTooltipsResidentFromJSONTyped(json, false);
}

export function IntegrationEventTooltipsResidentFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventTooltipsResident {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function IntegrationEventTooltipsResidentToJSON(value?: IntegrationEventTooltipsResident | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

